import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { EigentuemerPrintOptionsMeta, GrundstueckPrintOptionsMeta, RechtPrintOptionsMeta } from '../../../../core/gb-api';
import { AuszugInfoItem, AuszugTypeEnum, FormatEnum } from '../auszug-print-service';

export type PrintOptions = RechtPrintOptionsMeta | GrundstueckPrintOptionsMeta | EigentuemerPrintOptionsMeta;

export interface AuszugPrintOptions {
  printOptions: PrintOptions;
  format: FormatEnum;
  auszugType: AuszugTypeEnum;
  item: AuszugInfoItem;
  hasToZip: boolean;
  ids: Array<string>;
  indexNumber: number;
}

@Injectable()
export class AuszugSettingsService {
  private confirmedPrintOptionsSelection = new Subject<AuszugPrintOptions>();
  public confirmedPrintSelection$ = this.confirmedPrintOptionsSelection.asObservable();

  constructor() {}

  confirmPrintSelection(selection: AuszugPrintOptions) {
    this.confirmedPrintOptionsSelection.next(selection);
  }
}
